import { cva } from 'class-variance-authority'

export const statusTagRootVariant = cva('rounded-full text-center text-white', {
  variants: {
    color: {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      info: 'bg-info',
      green: 'bg-green',
      yellow: 'bg-yellow',
      red: 'bg-red',
      'orange-5': 'bg-orange-5',
      'orange-6': 'bg-orange-6',
      'orange-7': 'bg-orange-7',
      'blue-5': 'bg-blue-5',
      'green-7': 'bg-green-7',
      'green-8': 'bg-green-8'
    },
    block: {
      true: '',
      false: 'inline-block'
    },
    size: {
      default: 'px-3 py-[7px] leading-tight',
      small: 'px-3 py-1 text-xs leading-none'
    }
  }
})
